import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const StyledAdditionalLinksContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${SPACING.SMALL_5} 0 ${SPACING.SMALL} 0;
`;
